var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8714 18.1112C50.7731 25.157 49.9649 33.1865 45.7138 39.5128L58.8235 52.6272C60.4331 54.3555 60.3852 57.0473 58.7162 58.7162C57.0473 60.3852 54.3555 60.4331 52.6272 58.8235L39.5128 45.7138C33.1865 49.9649 25.1571 50.7731 18.1113 47.8713C11.0655 44.9671 5.93769 38.7366 4.44227 31.2642C2.94895 23.7917 5.28917 16.0655 10.6774 10.6773C16.0656 5.28921 23.7918 2.94904 31.2642 4.44219C38.7367 5.93785 44.9672 11.0654 47.8714 18.1112ZM37.3144 30.3004C38.2824 30.3004 39.0678 29.515 39.0678 28.547V25.0401C39.0678 24.0721 38.2824 23.2867 37.3144 23.2867H30.3008H23.2871H16.2735C15.3055 23.2867 14.5201 24.0721 14.5201 25.0401V28.547C14.5201 29.515 15.3055 30.3004 16.2735 30.3004H23.2871H30.3008H37.3144Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom_out.51005a0e.svg";
export { ForwardRef as ReactComponent };